/* Yummy Gummy — Supplement Facts drawer open/close.
   Mirrors assets/cart-drawer.js's own open()/close() shape (class-toggle
   + a timeout so the transition reliably triggers, trapFocus/
   removeTrapFocus from assets/global.js, the .overflow-hidden body-lock
   utility) rather than reinventing drawer behavior. global.js is loaded
   sitewide as a classic (non-module) script, so trapFocus/removeTrapFocus
   are genuinely available here as globals — confirmed, not assumed. */
(function () {
  'use strict';

  function init() {
    var drawer = document.querySelector('[data-pdp-facts-drawer]');
    // ALL triggers, not just the first — the "View Supplement Facts" button
    // AND the "See all ingredients" link both open this same drawer.
    var triggers = document.querySelectorAll('[data-pdp-facts-trigger]');
    if (!drawer || !triggers.length || drawer.__pdpBound) return;
    drawer.__pdpBound = true;

    var panel = drawer.querySelector('.pdp-fd__panel');
    var openedBy = null;
    var scrollY = 0;

    function open(event) {
      // Remember which control opened it so focus returns there on close.
      openedBy = (event && event.currentTarget) || triggers[0];
      drawer.hidden = false;
      // Matches cart-drawer.js's own comment: the transition doesn't
      // always trigger without yielding a frame first.
      window.setTimeout(function () {
        drawer.classList.add('is-active');
      });
      // .overflow-hidden puts overflow:hidden on <body>, which makes the
      // browser forget where the page was scrolled to — closing the drawer
      // then dropped the reader back at the top, well above the section they
      // opened it from. Hold the position here and restore it on close.
      scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.classList.add('overflow-hidden');

      drawer.addEventListener(
        'transitionend',
        function () {
          if (typeof trapFocus === 'function') trapFocus(panel, panel);
        },
        { once: true }
      );
    }

    function close() {
      drawer.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden');

      // Focus first, then restore the scroll. Two separate things move the page
      // here: unlocking <body> loses the scroll position, and global.js's
      // removeTrapFocus calls .focus() without preventScroll, which makes the
      // browser scroll the trigger into view. Restoring before that focus meant
      // the focus call simply moved the page again — so focus goes first and
      // the position is set last, with a rAF to land after the browser's own
      // scroll-into-view.
      if (typeof removeTrapFocus === 'function') removeTrapFocus(openedBy);
      window.scrollTo(0, scrollY);
      window.requestAnimationFrame(function () { window.scrollTo(0, scrollY); });

      drawer.addEventListener(
        'transitionend',
        function () {
          if (!drawer.classList.contains('is-active')) drawer.hidden = true;
        },
        { once: true }
      );
    }

    triggers.forEach(function (t) { t.addEventListener('click', open); });
    drawer.querySelectorAll('[data-pdp-facts-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.addEventListener('keyup', function (e) {
      if (e.code === 'Escape') close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
